export type Costs = {
  shipping: string;
  insurance: string;
  installation: string;
  other: string;
};
export type Workspace = {
  offerStatus: string;
  rfq: {
    rfqNo: string;
    title: string;
    deadlineAt: string;
    timezone: string;
    specificationVersion: string;
    items: Array<{
      id: string;
      lineNo: number;
      itemCode: string;
      description: string;
      quantity: number;
      unit: string;
      deliveryDate: string | null;
    }>;
  };
  draft: null | {
    status: string;
    version: number;
    currency: string;
    deliveryLeadDays: number;
    paymentTermDays: number;
    validityDate: string;
    additionalCosts: Costs;
    serverGrandTotal: string | null;
    note: string;
    items: Array<{ rfqItemId: string; unitPrice: string; serverTotal: string }>;
    documents: Array<{
      id: string;
      originalName: string;
      securityStatus: string;
    }>;
  };
  history: Array<{
    id: string;
    version: number;
    currency: string;
    grandTotal: string;
    submittedAt: string;
  }>;
};
export type PortalCommunications = {
  questions: Array<{
    id: string;
    body: string;
    status: string;
    createdAt: string;
    answer: null | {
      body: string;
      visibility: "ALL_INVITEES" | "PRIVATE";
      answeredAt: string;
    };
  }>;
  announcements: Array<{
    id: string;
    body: string;
    visibility: "ALL_INVITEES" | "PRIVATE";
    createdAt: string;
  }>;
};
export const labels: Record<string, string> = {
  DRAFT: "Taslak",
  SUBMITTING: "Gönderiliyor",
  SUBMITTED: "Gönderildi",
  REJECTED: "Katılım reddedildi",
  EXPIRED: "Süresi doldu",
};
export const money = (v: string | number, c: string) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: c }).format(
    Number(v),
  );
